/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ManagedCollectionKind = typeof ManagedCollectionKind[keyof typeof ManagedCollectionKind];


export const ManagedCollectionKind = {
  subcategory: 'subcategory',
  editorial: 'editorial',
  personal: 'personal',
} as const;
